import { render } from "./ModalSendInvite.vue?vue&type=template&id=c1c0bde8&scoped=true"
import script from "./ModalSendInvite.vue?vue&type=script&lang=js"
export * from "./ModalSendInvite.vue?vue&type=script&lang=js"

import "./ModalSendInvite.vue?vue&type=style&index=0&id=c1c0bde8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c0bde8"]])

export default __exports__